// extracted by mini-css-extract-plugin
module.exports = {"button":"button__2YHwx","inner":"inner__A9sCZ","spinner":"spinner__17DQZ","primary":"primary__26o4Y"};